import $api from "@/core/services/ApiService";
import { AxiosRequestConfig } from "axios";
import WhiteLabelEndpoint from "@/core/services/api/endpoints/manager/WhiteLabelEndpoint";

type Period = "day" | "month";

interface VolumeRequest {
  period?: Period;
  date_start?: string;
  date_end?: string;
}

class CompanyEndpoint {
  constructor(
    public white_label: WhiteLabelEndpoint = new WhiteLabelEndpoint()
  ) {}

  public view() {
    return $api.get("manager/company");
  }

  public alerts() {
    return $api.get("manager/company/alerts");
  }

  public statistic() {
    return $api.get("manager/company/statistic");
  }

  public statisticTransactionVolume(params?: VolumeRequest | null) {
    const request = {} as AxiosRequestConfig;
    if (params) {
      request.params = params;
    }

    return $api.get("manager/company/statistic/transaction-volume", request);
  }

  public statisticAccountVolume(params?: VolumeRequest | null) {
    const request = {} as AxiosRequestConfig;
    if (params) {
      request.params = params;
    }

    return $api.get(
      "manager/company/statistic/accounts-transaction-volume",
      request
    );
  }
}

export default CompanyEndpoint;
